export default {
  copyFeatureAndTestCase({ commit }, params) {
    if (params?.response?.data?.status == 'SUCCESS') {
      this.dispatch('OpenNotification', { message: '复制成功', type: 'success' })
    }
  }
}
